import React, { FC } from 'react';
import { Icons } from '@/components/icons';

interface IProps {
  title: string;
  description: string;
  items: {
    title: string;
    description: string;
    list: { title: string; description: string }[];
    footerText?: string;
  }[];
}

export const ContentWeOfferV2: FC<IProps> = ({ title, description, items }) => {
  return (
    <div>
      {title && (
        <h2 className=" mb-14 flex items-center gap-2 text-left text-4xl font-semibold">
          <span>
            <Icons.serviceIcon />
          </span>
          <span>{title}</span>
        </h2>
      )}

      {description && (
        <p
          className="description-with-links mb-4 text-left"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

      <ul className="flex list-disc flex-col gap-y-6">
        {items.map((item) => (
          <li key={item.title} className="list-none">
            <div className="mb-4 flex w-full items-center gap-4">
              <span>
                <Icons.serviceIcon />
              </span>
              <h3 className="text-left  text-2xl">{item.title}</h3>
            </div>

            {item.description && (
              <p
                className="description-with-links mb-4 text-left"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            )}

            {!!item.list.length && (
              <ul
                className={`ml-6 flex w-full list-disc flex-col gap-y-1.5 ${item.footerText ? 'mb-2' : 'mb-10'}`}
              >
                {item.list.map((item) => (
                  <li
                    key={item.title}
                    className="mb-4 text-left text-base font-normal"
                  >
                    {item.title && (
                      <span className="font-semibold">{item.title}</span>
                    )}{' '}
                    {item.description && (
                      <span
                        className="description-with-links"
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      />
                    )}
                  </li>
                ))}
              </ul>
            )}

            {item.footerText && (
              <p
                className="description-with-links mb-10 text-left"
                dangerouslySetInnerHTML={{ __html: item.footerText }}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
